module.exports = __webpack_public_path__ + "static/media/048-On The Docks.bb8b1adf.jpeg";